module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/125.fe69cf6d.png";